import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { registerApi } from "../../api/auth.api";
import { toast } from "react-toastify";
import "./Auth.css";
import dpPowerWorld from "../../assets/images/DP_Power_world.png";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PasswordStrength from "../../components/PasswordStrength/PasswordStrength";

export default function Register() {
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const passwordsMatch =
    password && confirmPassword && password === confirmPassword;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!passwordsMatch) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      await registerApi({
        full_name: fullName,
        email,
        password,
      });
      toast.success("Account created successfully");
      navigate("/login");
    } catch (err) {
      toast.error(err.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-card">
      <div className="auth-logo-wrap">
        <img
          src={dpPowerWorld}
          alt="DP Power World"
          className="auth-logo-img"
        />
      </div>
      <h1 className="auth-title">Create Account</h1>

      <form onSubmit={handleSubmit}>
        <div className="auth-field">
          <input
            className="auth-input no-extra-padding"
            placeholder="Full name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
          />
        </div>

        <div className="auth-field">
          <input
            className="auth-input no-extra-padding"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="auth-field">
          <div className="auth-input-wrap">
            <input
              className="auth-input"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="auth-toggle-pwd"
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </button>
          </div>
        </div>

        <div className="auth-field">
          <input
            className="auth-input no-extra-padding"
            type={showPassword ? "text" : "password"}
            placeholder="Confirm password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        {confirmPassword && (
          <p className={passwordsMatch ? "auth-match-ok" : "auth-match-bad"}>
            {passwordsMatch ? "Passwords match" : "Passwords do not match"}
          </p>
        )}

        <PasswordStrength password={password} />

        <button type="submit" disabled={loading} className="auth-btn">
          {loading ? "Creating..." : "Create account"}
        </button>
      </form>

      <p className="auth-footer">
        Already have an account?
        <Link to="/login" className="auth-link">
          Login
        </Link>
      </p>
    </div>
  );
}
